import { Component, inject } from '@angular/core';
import { SaleMethodService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SaleMethodCreateDto,
  SaleMethodDto,
  SaleMethodExcelDownloadDto,
  SaleMethodUpdateDto,
} from '../proxy/controlling/dtos/sale-method';
import { SALEMETHOD_CONFIG, SALEMETHOD_FIELDS } from './sale-method.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sale-method',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SaleMethodService, ConfirmationService],
  templateUrl: './sale-method.html',
  styleUrl: './sale-method.scss',
})
export class SaleMethod extends BaseCrudComponent<
  SaleMethodDto,
  SaleMethodCreateDto,
  SaleMethodUpdateDto,
  SaleMethodExcelDownloadDto
> {
  service = inject(SaleMethodService);
  config = SALEMETHOD_CONFIG;
  fields = SALEMETHOD_FIELDS;

  protected prepareUpdateDto(data: any, selected: SaleMethodDto): SaleMethodUpdateDto {
    return {
      name: data.name,
      value: data.value,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SaleMethod';
  }
}
